export default function isBlank(value: string): boolean {
  return value.trim().length === 0;
}
